import '@/App.css';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import HomePage from './pages/HomePage';
import { cities } from './data/cities';
import { neighborhoods } from './data/neighborhoods';
import { Toaster } from './components/ui/toaster';
import ScrollToTop from './components/ScrollToTop';
import MobileContactFAB from './components/MobileContactFAB';

const ContactPage = lazy(() => import('./pages/ContactPage'));
const PropertiesPage = lazy(() => import('./pages/PropertiesPage'));
const AboutPage = lazy(() => import('./pages/AboutPage'));
const ServicesPage = lazy(() => import('./pages/ServicesPage'));
const TestimonialsPage = lazy(() => import('./pages/TestimonialsPage'));
const TermsPage = lazy(() => import('./pages/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/PrivacyPage'));
const CityPage = lazy(() => import('./pages/CityPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));
const NeighborhoodPage = lazy(() => import('./pages/NeighborhoodPage'));
const BlogIndexPage = lazy(() => import('./pages/BlogIndexPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));

function App() {
  return (
    <HelmetProvider>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[100] focus:bg-white focus:text-gray-900 focus:px-4 focus:py-2 focus:rounded focus:shadow-lg focus:outline focus:outline-2 focus:outline-gray-900"
      >
        Skip to main content
      </a>
      <div className="App" id="main-content">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/properties" element={<PropertiesPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/testimonials" element={<TestimonialsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPage />} />
              <Route path="/blog" element={<BlogIndexPage />} />
              <Route path="/blog/:slug" element={<BlogPostPage />} />
              {Object.entries(cities).map(([key, city]) => (
                <Route
                  key={key}
                  path={`/${city.slug}`}
                  element={<CityPage cityKey={key} />}
                />
              ))}
              {Object.entries(neighborhoods).map(([key, n]) => (
                <Route
                  key={key}
                  path={`/${n.slug}`}
                  element={<NeighborhoodPage neighborhoodKey={key} />}
                />
              ))}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster />
        <MobileContactFAB />
      </div>
      <a href="#main-content" className="hidden" aria-hidden="true" tabIndex={-1}>end</a>
    </HelmetProvider>
  );
}

export default App;
